module.exports = __webpack_public_path__ + "img/img-empty-state-rides.da7668c7.svg";